import { SubmissionError } from 'redux-form';

const getErrorMessage = (error) => {
  try {
    if (error == null) return 'Request failed';
    if (typeof error === 'string' && error.trim()) return error;

    if (Array.isArray(error.graphQLErrors) && error.graphQLErrors.length > 0) {
      return error.graphQLErrors
        .filter(Boolean)
        .map((e) => (e && e.message) || 'GraphQL error')
        .join(' ');
    }

    const ne = error.networkError;
    if (ne != null && typeof ne === 'object') {
      if (typeof ne.message === 'string' && ne.message) return ne.message;
      const first = ne.result && Array.isArray(ne.result.errors) && ne.result.errors[0];
      if (first && typeof first.message === 'string') return first.message;
      if (typeof ne.statusCode === 'number') {
        return `Network error (${ne.statusCode})`;
      }
    }

    if (typeof error.message === 'string' && error.message) {
      return error.message;
    }
    return 'Request failed';
  } catch (_) {
    return 'Request failed';
  }
};

const parseFormErrors = (error) => {
  let message = 'Request failed';
  try {
    message = getErrorMessage(error);
  } catch (_) {
    if (error && typeof error.message === 'string' && error.message) {
      message = error.message;
    }
  }
  throw new SubmissionError({ _error: message });
};

export { parseFormErrors };
